module.exports = __webpack_public_path__ + "s/img/logo-archer-256x42.abde3ded.png";